import { NgClass } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  forwardRef,
  Input,
  Output,
} from '@angular/core';
import { NG_VALIDATORS, NG_VALUE_ACCESSOR, ReactiveFormsModule } from '@angular/forms';

import { BaseFormControlComponent } from '../base-form-control/base-form-control';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ReactiveFormsModule, NgClass],
  providers: [
    {
      multi: true,
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => CheckboxControlComponent),
    },
    {
      multi: true,
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => CheckboxControlComponent),
    },
  ],
  selector: 'aux-checkbox-control',
  styleUrls: ['./checkbox.component.scss'],
  templateUrl: './checkbox-control.component.html',
})
export class CheckboxControlComponent extends BaseFormControlComponent<boolean> {
  @Input() checked = false;
  @Output() customChange = new EventEmitter<boolean>();
  @Input() disabled = false;
  @Input() id = '';
  @Input() indeterminate = false;

  onCheckboxChange(event: Event) {
    const input = event.target as HTMLInputElement;

    this.checked = input.checked;
    this.onChange(this.checked);
    this.onTouched();
    this.customChange.emit(this.checked);
  }
}
